export class StageWithTemplates {
  ['default']?: boolean;

  constructor(
    public id: string = '',
    public name: string = '',
    public description: string = '',
    public createdBy: string = '',
    public createdDate: string = '',
    public notificationTemplates: TemplateId[] = [],
    public deleted: boolean = false,
    public defaultStage: boolean = false,
    public isDefault: boolean = false
  ) {}
}

export class TemplateId {
  ['default']?: boolean;

  constructor(
    public createdBy: string = '',
    public createdDate: string = '',
    public id: string = '',
    public name: string = '',
    public template: string = '',
    public isDefault: boolean = false
  ) {}
}

export class Template {
  constructor(
    public name: string = '',
    public template: string = ''
  ) {}
}
